import { Link } from "@mui/material";

const Prostrategies = () => {
  return (
    <div className="container--blog_post_page_wrapper">
      <section className="container--blog_post">
        <div className="container--post_content">
          <h2 className="header header--page_title_h2_left">
            Yes, networking is still important. No, it doesn’t have to be
            old-school.
          </h2>
          <p className="text--post_paragraph">
            For many, networking may sound like a stuffy term that brings forth
            the image of a room filled with elite, wealthy, and not-so-diverse
            people. At the most basic level, networking is a way to meet new
            people. What sets this term apart from other ways of meeting new
            people are one’s intentions and goals. Networking can be as meeting
            some locals at a bar to watch a game and asking them about their
            work and hobbies because you care to know, or it can be as strategic
            as attending a professional conference, leadership summit, or career
            fair with the aim of gaining new skills, knowledge, or making a
            connection that may lead to an interview.
          </p>
          <p className="text--post_paragraph">
            Either way, it’s important for both human connection and career
            development. In fact, 80% of professionals believe that{" "}
            <Link
              href="https://techjury.net/blog/networking-statistics/#gref"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read about the impact of professional networking on Techjury"
            >
              career success
            </Link>{" "}
            can be elevated through professional networking. With new
            technologies, a{" "}
            <Link
              href="https://www.forbes.com/sites/shelleyzalis/2021/09/20/the-future-of-work-has-arrived-now-what/?sh=56b328542c0b"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Explore the future of work trends on Forbes"
            >
              future-of-work
            </Link>{" "}
            landscape that is rapidly evolving, paired with demographics showing{" "}
            <Link
              href="https://www.catalyst.org/research/generations-demographic-trends-in-population-and-workforce/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read about demographic trends in workforce on Catalyst"
            >
              millennials
            </Link>{" "}
            dominating the workforce, networking can be redefined as desired and
            can take on a more relevant meaning for today’s professionals.
            Instead of overanalyzing what networking is or isn’t, professionals
            should prioritize community building as an asset to professional and
            personal growth.
          </p>
          <h2 className="header header--page_title_h2_left">
            What if I don’t know what my goal is?
          </h2>
          <p className="text--post_paragraph">
            If you feel overwhelmed by the pressures to perform, excel, and stay
            visible all while wondering if you’re taking the right approach,
            take a breath and know that you aren’t alone. Intention and goals
            are important, but they don’t have to be statutory, and you can edit
            them over time as you learn and grow. Keep reading for actionable
            steps you can take to make progress today!
          </p>
          <h2 className="header header--page_title_h2_left">
            Start by asking yourself some questions...
          </h2>
          <p className="text--post_paragraph">
            What do you want from your networking experience? And, is there
            something you need that convinced you to network in the first place?
            Do you want to ideate and get comfortable speaking on a particular
            topic or new idea you’ve been sitting on? Do you need to find a job?
            Do you feel like you have a wealth of knowledge or skill you want to
            share with others? Do you need to find other talented people to help
            you with a project?
          </p>
          <div>
            <ul>
              <h3 className="header--page_title_h3_left">
                &#8594;&nbsp; If your main intention is to fill a need—
              </h3>
              <p className="text--post_paragraph">
                {" "}
                like finding some talented freelancers who can help you complete
                a project, you will need to more closely consider your tactics
                in filling that need. When seeking to fill a need, the achieved
                goal will likely result in finding a place on a team (a job) or
                building out a team (seeking talent).{" "}
              </p>
            </ul>
          </div>
          <div>
            <ul>
              <h3 className="header--page_title_h3_left">
                &#8594;&nbsp; However, If your main goal is more of a want—
              </h3>
              <p className="text--post_paragraph">
                like building a few more quality connections on Linkedin with
                people who are doing interesting work you want to keep up with,
                your approach is going to be highly customizable and flexible.
                Don’t skip out on achieving your wants because it is a great way
                to build a network built on broad interest and deep connections
                that will be an undeniable asset.
              </p>
            </ul>
          </div>
          <h2 className="header header--page_title_h2_left">
            Both In-Person and Virtual Networking Can Be Great Options!
          </h2>
          <p className="text--post_paragraph">
            The ways in which society has used technology to keep people
            connected, working, and learning during the pandemic is one of its
            few positive outcomes. Pre-pandemic, most people would advise
            networking and building teams in person. However, with customizable
            features for hosts of virtual events, there are new ways to
            encourage people to meaningfully engage online. Additionally, data
            indicates{" "}
            <Link
              href="https://www.valuepenguin.com/news/employees-prefer-remote-work"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read about employee preferences for remote work on ValuePenguin"
            >
              68% of U.S. employees now prefer remote work
            </Link>{" "}
            over going into an office. As a result of a global threat that
            forced our hand in how we work and engage, people have shown great
            adaptability and learned to make new systems work better for them.
          </p>
          <h2 className="header header--page_title_h2_left">
            What to consider when joining or finding a team.
          </h2>
          <p className="text--post_paragraph">
            When evaluating the best ways to network with the intention of
            filling a need, it’s important to decide what you are able or
            willing to invest. If you want to save your hard-earned cash, don’t
            currently have an income, or don’t quite know your exact target for
            landing a job, consider tailoring your networking approach towards
            low-to-no-cost platforms. Attend free{" "}
            <Link
              href="https://www.forbes.com/sites/forbesagencycouncil/2021/02/10/with-virtual-events-likely-here-to-stay-make-them-succeed-for-you/?sh=330e738890d4"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Learn how to succeed with virtual events on Forbes"
            >
              virtual conferences
            </Link>{" "}
            ,events, or start accounts with networking platforms that meet your
            needs without charging. There are plenty of high-quality options
            available right from your{" "}
            <Link
              href="https://www.google.com/search?q=free+networking+conferences&oq=free+networking+conferences&aqs=chrome..69i57j0i22i30.6686j1j4&sourceid=chrome&ie=UTF-8"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Search for free networking conferences on Google"
            >
              search engine
            </Link>
            . These low-cost tactics are also a great way for small businesses
            and start-ups to attract talent at little-to-no cost.
          </p>
          <p className="text--post_paragraph">
            Another great tool is{" "}
            <Link
              href="http://linkedin.com"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Visit LinkedIn for professional networking"
            >
              Linkedin
            </Link>
            . Whether you are networking in person or virtually, everyone should
            have a Linkedin account, and this platform is one of the best places
            to shop for other free networking opportunities. Spend time{" "}
            <Link
              href="https://www.linkedin.com/business/sales/blog/profile-best-practices/17-steps-to-a-better-linkedin-profile-in-2017"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Learn about creating a better LinkedIn profile on LinkedIn Business"
            >
              creating
            </Link>{" "}
            or sprucing up your profile and start making those connections!
          </p>
          <p className="text--post_paragraph">
            Additionally, virtual networking opportunities can be a smart way to
            meet with a diverse group of people, make quick connections on
            Linkedin (which increases the volume of opportunities/and or skilled
            people you’ll see on your feed), and heighten your personal or
            professional brand. For those looking to recruit, free networking
            events are an effective way to attract diverse talent and are
            innately more inclusive.
          </p>
          <p className="text--post_paragraph">
            If you have a bit more time and/or money to invest, you might choose
            to opt for something local (e.g. purchase a{" "}
            <Link
              href="https://www.workbar.com/benefits-of-coworking-spaces/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read about the benefits of coworking spaces on Workbar"
            >
              coworking
            </Link>{" "}
            membership), or register to attend an in-person, industry-specific
            event (e.g.&nbsp;
            <Link
              href="https://www.asugsvsummit.com/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Learn about the ASU + GSV Summit for educational innovation"
            >
              ASU + GSV Summit
            </Link>
            ). Keep in mind, too, that many of the world’s biggest networking
            brands are now offering hybrid events to help individuals find the
            best fit for their lifestyle.
          </p>
          <h2 className="header header--page_title_h2_left">
            Don’t let the overwhelm keep you from accessing opportunities.
          </h2>

          <p className="text--post_paragraph">
            Networking can enable you to meet others, learn new skills, build a
            brand, give back to your community, and earn money. Whether you opt
            for a free platform like{" "}
            <Link
              href="http://linkedin.com"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
            >
              Linkedin
            </Link>
            , or layer on memberships or in-person events, there are many ways
            to network effectively, and you can achieve any number of goals
            through each. For those of us who have enjoyed being able to turn
            our zoom cameras off while sipping our coffee at home during
            meetings, or while job hunting, don’t worry.
          </p>
          <p className="text--post_paragraph">
            Networking can still work for you! Even though building a
            professional community and personal brand may feel intimidating, it
            is crucial for today’s working standards, and it is—thankfully— no
            longer designed with a one-size-fits-all approach.
          </p>
        </div>
        <br />
        <br />
        <hr className="hr--form_break" />
      </section>
    </div>
  );
};

export default Prostrategies;
